var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select",class:{ selected: _vm.value },on:{"click":function($event){return _vm.toggler()}}},[_c('i',{staticClass:"material-symbols-outlined"},[_vm._v("filter_list")]),_c('span',{staticClass:"title__small"},[_vm._t("title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }